module.exports = __webpack_public_path__ + "static/media/1101-3.7c357eb5.jpg";